import React from "react";
import { formatCurrency } from "../../../helpers/getSymbolFromCurrency";
import LuggageIcon from '@mui/icons-material/Luggage';

const VendorPriceRow = ({ rate }) => {
  const currency = rate.currency || "EUR";

  return (
    <div className="rate-analysis-vendor-row">
      <div className="rate-analysis-vendor-info">
        {rate.vendorLogo && (
          <img
            src={rate.vendorLogo}
            alt={rate.vendorName}
            className="rate-analysis-vendor-logo"
          />
        )}
        <div>
          <p className="rate-analysis-vendor-name">{rate.vendorName}</p>
          {rate.hasBaggageAssistance && (
            <div className="rate-analysis-service-tags">
              <span className="rate-analysis-service-tag">
                <LuggageIcon className="rate-analysis-service-tag-icon" />
                Baggage assistance
              </span>
            </div>
          )}
        </div>
      </div>

      <div className="rate-analysis-vendor-pricing">
        <span className="rate-analysis-price">
          {formatCurrency(currency, rate.price)}
        </span>
      </div>
    </div>
  );
};

export default VendorPriceRow;
